import React from "react";

export default function PortalAutogestion() {
  return (
    <section
      className="mt-[70px]  md:mt-[100px] lg:mt-[90px] px-2 md:px-0 flex h-full bg-sidom-light dark:bg-sidom-blue"
      tabIndex={0}
      aria-label="Portal de autogestión 24x7"
    >
      <div className="  relative flex flex-col items-center justify-center">
        <h1
          className="mb-[30px] md:mb-[60px] w-full text-sidom-orange text-3xl md:text-[40px] lg:text-[45px] md:text-5xl leading-[1.4] font-bold text-left"
          tabIndex={0}
          aria-label="Título: Transparencia y simplicidad en tu portal de autogestión"
        >
          <span className="font-normal text-sidom-dark dark:text-sidom-light leading-[1.4]">
            Transparencia y simplicidad en tu portal de
          </span>{" "}
          autogestión 24x7
        </h1>
        <div
          className="flex flex-col  mb-[70px] md:mb-[100px] lg:mb-[90px] text-xs sm:text-sm md:text-base lg:text-xl text-left leading-relaxed"
          tabIndex={0}
          aria-label="Descripción de SIDOM Insurance"
        >
          <h1>
            <strong>SIDOM INSURANCE </strong> es la primera solución InsurTech
            de Seguros embebidos para la{" "}
            <strong>
              gestión integral de las pólizas de transporte y garantías
              aduaneras
            </strong>{" "}
            relacionadas con la operatoria de comercio exterior.
          </h1>
          <h1 className="mt-[20px]">
            Permite cotizar y contratar todos los seguros de la operatoria de
            Impo/Expo de manera transparente y en tiempo real, logrando agilizar
            y simplificar los procesos logísticos
          </h1>
        </div>
      </div>
    </section>
  );
}
